import { GitHubBackend } from 'decap-cms-backend-github';
import { filterByExtension } from 'decap-cms-lib-util';
import { SupabaseClient } from './supabase';
export default class SupabaseGitHubProxyBackend extends GitHubBackend {
  constructor(config, options = {}) {
    super(config, options);
    this.supabaseAnonKey = config.backend.anon_key || config.backend.app_id || '';
    this.supabaseId = config.backend.app_id || '';
    this.supabase = new SupabaseClient(`https://${this.supabaseId}.supabase.co/rest/v1/data`, this.supabaseAnonKey, this.branch, this.originRepo);
  }
  async allEntriesByFolder(folder, extension, depth, pathRegex, searchTerm) {
    const repoURL = this.api.originRepoURL;
    const collection = `${folder}:${extension}:${depth}:${pathRegex?.toString() || 'all'}`;
    const files = (await this.api.listFiles(folder, {
      repoURL,
      depth
    })).filter(file => (!pathRegex || pathRegex.test(file.path)) && filterByExtension(file, extension));
    const readFile = (path, id) => this.api.readFile(path, id, {
      repoURL
    });
    await this.supabase.validateFiles(collection, files, readFile, this.api.readFileMetadata.bind(this.api));
    const entries = await this.supabase.fetchEntries(collection, searchTerm);
    const fileIdToIndex = new Map(files.map((file, index) => [file.id, index]));
    entries.sort((a, b) => {
      const indexA = fileIdToIndex.get(a.file.id) ?? Number.MAX_SAFE_INTEGER;
      const indexB = fileIdToIndex.get(b.file.id) ?? Number.MAX_SAFE_INTEGER;
      return indexA - indexB;
    });
    return entries;
  }
}